<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content [scrollY]="true">
  <ion-label class="title"> {{'INSIGHTS.metrics.modal.title.' + metricName | translate }} </ion-label>
  <ion-label class="subtitle">{{'INSIGHTS.metrics.modal.q_how' | translate }}</ion-label>
  <p [innerHtml]="'INSIGHTS.metrics.modal.answer_how.' + metricName | translate"></p>
  <ion-label class="subtitle">{{'INSIGHTS.metrics.modal.q_why' | translate }}</ion-label>
  <p>{{'INSIGHTS.metrics.modal.answer_why.' + metricName | translate }}</p>
</ion-content>
